/* TinkleGo cart drawer extras: free shipping progress bar and guarantee note.
   Dawn re-renders the drawer after every cart change, so the bar is re-inserted when that happens. */
(function () {
  var THRESHOLD = 5900; // cents. Keep in sync with the US free shipping rate in Settings > Shipping.
  var timer = null;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function barHtml(cart) {
    var left = THRESHOLD - cart.total_price;
    var pct = Math.max(6, Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)));
    var msg = left > 0
      ? '<strong>' + money(left) + '</strong> away from free shipping'
      : '<strong>You\'ve got free shipping.</strong>';
    return '<p class="tg-cartbar__msg">' + msg + '</p><div class="tg-cartbar__track" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
  }

  function paint(cart) {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (!inner) return;
    var bar = inner.querySelector('.tg-cartbar');
    var note = inner.querySelector('.tg-cartnote');
    var show = cart.item_count > 0 && cart.currency === 'USD';
    if (!show) {
      if (bar) bar.remove();
      if (note) note.remove();
      return;
    }
    if (!bar) {
      var header = inner.querySelector('.drawer__header');
      if (!header) return;
      bar = document.createElement('div');
      bar.className = 'tg-cartbar';
      bar.setAttribute('role', 'status');
      header.insertAdjacentElement('afterend', bar);
    }
    var html = barHtml(cart);
    if (bar.innerHTML !== html) bar.innerHTML = html;
    if (!note) {
      var ctas = inner.querySelector('.cart__ctas');
      if (ctas) {
        note = document.createElement('p');
        note.className = 'tg-cartnote';
        note.textContent = '30-day money-back guarantee. Keep the potty.';
        ctas.insertAdjacentElement('beforebegin', note);
      }
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {});
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 120); }

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    refresh();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && t.closest('.tg-cartbar, .tg-cartnote')) continue;
        schedule();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
